import { fabric } from 'fabric'
import { v4 as uuidv4 } from 'uuid'

export const ParseShortsAnalysisToMaterial = ({
    layout,
    topic,
    sentences,
    allSentences,
    volume = 1,
    playbackSpeed = 1
}) => {

    const material = {
        layout,
        topic,
        sentences: [],
        allSentences: [],
        volume,
        playbackSpeed
    }
    topic.id = 'topic'
    topic.type = 'topic'
    const enabledSentenceMap = {}
    
    sentences.forEach(sentence => {
        const obj = {
            ...sentence,
            id: sentence.id || uuidv4(),
            type: 'sentence',
            enabled: true
        }
        delete obj.words

        material.sentences.push(obj)
        enabledSentenceMap[sentence.index] = obj
    })

    allSentences.forEach(sentence => {
        if (!enabledSentenceMap[sentence.index]) {
            const obj = {
                ...sentence,
                id: sentence.id || uuidv4(),
                type: 'sentence',
                enabled: false
            }
            delete obj.words
            material.allSentences.push(obj)
        }
    })
    material.allSentences.push(...material.sentences)

    material.sentences.sort((a, b) => a.start - b.start)
    material.allSentences.sort((a, b) => a.start - b.start)

    return material
}

export const CombineMaterialAndFabricTexts = ({
    material: {
        layout,
        topic,
        sentences,
        allSentences,
        volume,
        playbackSpeed
    },
    topicFabricText,
    sentenceFabricTexts,
    currentScale = 1
}) => {
    const exportTextOptionFromFabricText = (fabricText) => {
        if (fabricText instanceof fabric.IText) {
            return {
                left: fabricText.left,
                top: fabricText.top,
                scaleX: fabricText.scaleX * currentScale,
                scaleY: fabricText.scaleY * currentScale,
                fontSize: fabricText.fontSize,
                fill: fabricText.fill,
                textAlign: fabricText.textAlign,
                linethrough: fabricText.linethrough,
                fontWeight: fabricText.fontWeight,
                fontStyle: fabricText.fontStyle,
                underline: fabricText.underline,
                lineHeight: fabricText.lineHeight,
                strokeWidth: fabricText.strokeWidth,
                stroke: fabricText.stroke,
                fontFamily: fabricText.fontFamily,
            }
        }
        return null
    }

    const result = {
        layout,
        topic,
        sentences,
        allSentences,
        volume,
        playbackSpeed
    }

    const sentenceFabricTextMap = {}
    sentenceFabricTexts.forEach(fabricText => {
        sentenceFabricTextMap[fabricText.textId] = fabricText
    })

    topic.textOptions = exportTextOptionFromFabricText(topicFabricText)
    sentences.forEach(sentence => {
        if (sentenceFabricTextMap[sentence.id]) {
            sentence.textOptions = exportTextOptionFromFabricText(sentenceFabricTextMap[sentence.id])
        }
    })
    allSentences.forEach(sentence => {
        if (sentenceFabricTextMap[sentence.id]) {
            sentence.textOptions = exportTextOptionFromFabricText(sentenceFabricTextMap[sentence.id])
        }
    })

    return result
}